module.exports = __webpack_public_path__ + "static/media/433576913_289938194129569_3058868092507614273_n.6a28ac72.jpg";